import React from "react";
import { Form, Row, Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ChatbotSettings } from "../types";

interface RetrievalSettingsProps {
  settingsData: ChatbotSettings;
  setSettingsData: React.Dispatch<React.SetStateAction<ChatbotSettings>>;
  setDirtySettings?: (dirty: boolean) => void;
}

const RetrievalSettings: React.FC<RetrievalSettingsProps> = ({
  settingsData,
  setSettingsData,
  setDirtySettings,
}) => {
  const { t } = useTranslation();
  const handleChange = (section: "retrieval" | "limits", key: string, value: number) => {
    setSettingsData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: value,
      },
    }));
    if (setDirtySettings) setDirtySettings(true);
  };

  return (
    <Row>
      <Col md={6}>
        <Card className="glass-card mb-3 retrieval-settings-card">
          <Card.Header className="gradient-card-header">
            {t("chatbots_edit.retrieval_settings")}
          </Card.Header>
          <Card.Body>
            <div className="retrieval-grid">
              <div className="retrieval-item">
                <Form.Label className="retrieval-label">{t("chatbots_edit.top_k")}</Form.Label>
                <Form.Control
                  type="number"
                  name="top_k"
                  value={settingsData.retrieval?.top_k || 5}
                  onChange={(e) =>
                    handleChange("retrieval", "top_k", Number(e.target.value))
                  }
                  className="retrieval-input"
                />
                <small className="text-muted">
                  {t("chatbots_edit.top_k_desc")}
                </small>
              </div>

              <div className="retrieval-item">
                <Form.Label className="retrieval-label">
                  {t("chatbots_edit.snippet_chars")}
                </Form.Label>
                <Form.Control
                  type="number"
                  name="snippet_chars"
                  value={settingsData.retrieval?.snippet_chars || 500}
                  onChange={(e) =>
                    handleChange(
                      "retrieval",
                      "snippet_chars",
                      Number(e.target.value)
                    )
                  }
                  className="retrieval-input"
                />
                <small className="text-muted">{t("chatbots_edit.snippet_chars_desc")}</small>
              </div>

              <div className="retrieval-item">
                <Form.Label className="retrieval-label">{t("chatbots_edit.chunk_size")}</Form.Label>
                <Form.Control
                  type="number"
                  name="chunk_size"
                  value={settingsData.retrieval?.chunk_size || 500}
                  onChange={(e) =>
                    handleChange("retrieval", "chunk_size", Number(e.target.value))
                  }
                  className="retrieval-input"
                />
                <small className="text-muted">{t("chatbots_edit.chunk_size_desc")}</small>
              </div>

              <div className="retrieval-item">
                <Form.Label className="retrieval-label">
                  {t("chatbots_edit.chunk_overlap")}
                </Form.Label>
                <Form.Control
                  type="number"
                  name="chunk_overlap"
                  value={settingsData.retrieval?.chunk_overlap || 60}
                  onChange={(e) =>
                    handleChange(
                      "retrieval",
                      "chunk_overlap",
                      Number(e.target.value)
                    )
                  }
                  className="retrieval-input"
                />
                <small className="text-muted">{t("chatbots_edit.chunk_overlap_desc")}</small>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>

      <Col md={6}>
        <Card className="glass-card mb-3 limits-performance-card">
          <Card.Header className="gradient-card-header">
            {t("chatbots_edit.limits_performance")}
          </Card.Header>
          <Card.Body>
            <div className="retrieval-grid">
              <div className="retrieval-item">
                <Form.Label className="retrieval-label">
                  {t("chatbots_edit.max_output_tokens")}
                </Form.Label>
                <Form.Control
                  type="number"
                  name="max_output_tokens"
                  value={settingsData.limits?.max_output_tokens || 450}
                  onChange={(e) =>
                    handleChange(
                      "limits",
                      "max_output_tokens",
                      Number(e.target.value)
                    )
                  }
                  className="retrieval-input"
                />
                <small className="text-muted">{t("chatbots_edit.max_output_tokens_desc")}</small>
              </div>

              <div className="retrieval-item">
                <Form.Label className="retrieval-label">
                  {t("chatbots_edit.cache_ttl")}
                </Form.Label>
                <Form.Control
                  type="number"
                  name="cache_ttl"
                  value={settingsData.limits?.cache_ttl_seconds || 3600}
                  onChange={(e) =>
                    handleChange(
                      "limits",
                      "cache_ttl_seconds",
                      Number(e.target.value)
                    )
                  }
                  className="retrieval-input"
                />
                <small className="text-muted">{t("chatbots_edit.cache_ttl_desc")}</small>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default RetrievalSettings;



